import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'archive-btn',
	template: require('./archive-btn.html')
})
export class ArchiveBtnComponent {
	@Input() text: string;
	@Input() isDisabled: boolean;
	@Output() action: EventEmitter<any> = new EventEmitter();

	constructor() {}

	onBtnClick(event): boolean {
		event.stopPropagation();
		this.action.emit();
		return false;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/buttons/archive-btn/archive-btn.ts